import { render, staticRenderFns } from "./Programms.vue?vue&type=template&id=08d09664&scoped=true&"
import script from "./Programms.vue?vue&type=script&lang=js&"
export * from "./Programms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d09664",
  null
  
)

export default component.exports